import { call, put, takeEvery, select } from 'redux-saga/effects'
import { toast } from 'react-toastify'

import MutationApi from '../../remote/mutationApi'

import { makeGetOrder } from '../../selectors/order'

import { orderDetailsRequested, saveOrder } from '../../actions/order'
import { TRANSFER_ORDER, transferOrderFailed } from '../../actions/orders/transfer'

import { selectRemoteOrderTotal } from '../../selectors/orderTotalRemote'

import { getUserNameFromCard, makeUserAttributes } from '../../utils/orderUtils'
import { DEFAULT_EXEMPTIONS } from '../../utils/orderTotalUtils'
import Log from '../../utils/Log'

const getOrder = makeGetOrder()

export function* transferOrder(params = {}) {
  const orderUuid = params?.payload?.orderId
  const customerId = params?.payload?.transferCustomerId

  if (!orderUuid || !customerId) {
    toast.error('Required: order and customer information needed')
    return
  }

  const order = yield select(getOrder, orderUuid)
  const { amountInCents } = order

  // payment logic
  const cardReaderData = params?.payload?.cardReaderData
  const isCardSwipe = !!cardReaderData

  const paymentType = params?.payload?.paymentType || 'cash'
  const isCash = paymentType === 'cash'

  const customerPaymentId = params?.payload?.customerPaymentId ?? null
  const isNewRemotePayment = customerPaymentId && customerPaymentId !== order?.customerPaymentId
  const isNewPayment = isCardSwipe || isCash || isNewRemotePayment

  const exemptionOverrides = {}
  const remoteOrderTotal = yield select(selectRemoteOrderTotal, exemptionOverrides)
  const promotions = remoteOrderTotal?.promotionParamsForClient ?? []

  let payload = {
    orderUuid,
    customerId,
  }

  if (isNewPayment) {
    let payments = { amountInCents, paymentType }
    if (isNewRemotePayment) payments['customerPaymentId'] = customerPaymentId
    payload = { ...payload, payments: [payments] }

    if (isCardSwipe) {
      // update payload to include the fp data in the userAttributes object
      const userAttributes = makeUserAttributes(cardReaderData)
      const userName = getUserNameFromCard(cardReaderData)

      payload = { ...payload, userAttributes, userName }
    }
  }

  function* handleError(errorMessage, errObject = {}) {
    if (isCardSwipe) {
      // TODO
      // if we're on the signature screen (close with new card), we should redirect back to the order details
    }

    Log.error(`Transfer order failed for order: ${order.orderNumber}`, {
      errorMessage,
      customerId,
      orderUuid,
    })

    yield put(transferOrderFailed({ ...errObject, orderUuid }))
  }

  try {
    const result = yield call(MutationApi.transferOrder, payload)
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      yield put(saveOrder({ uuid: orderUuid, customerPaymentId, paymentType, cardReaderData, exemptionOverrides, remoteOrderTotal }))
      yield put(orderDetailsRequested(orderUuid))
    } 
  } catch (err) {
    const errorMessage = err?.response?.data?.errorMessage ?? "Sorry, but something went wrong"
    yield handleError(errorMessage, err)
  }
}

export function* watchTransferOrder() {
  yield takeEvery(TRANSFER_ORDER, transferOrder)
}
